import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { hex2rgba } from '~/utils';

export const RowWrapper: StyleRule = () => ({
    borderBottom: `1px solid ${hex2rgba('#171616', 0.1)}`,
    justifyContent: 'center',
    width: '100%',
    paddingTop: pxToRem(4),
    paddingBottom: pxToRem(4),
    fontSize: pxToRem(16),
});

export const LabelWrapper: StyleRule = (props) => ({
    ...RowWrapper(props),
    justifyContent: 'unset',
    paddingTop: pxToRem(20),
});

export const ErrorText: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.danger[100],
    fontSize: pxToRem(12),
    alignSelf: 'flex-end',
    marginTop: pxToRem(4),
    marginRight: pxToRem(4),
});
